<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';
import notificationWithIcon from '@/utils/notification';

const b = bem('collection-frame-options');
export default {
  data() {
    return {
      options: {},
      isSelectedAll: false,
      subName: '',
      description: '',
      otherDesign: false,
    };
  },
  props: {
    selectedOptions: {
      type: Array,
      required: true,
    },
    frame: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
    selectedCollection: {
      type: Object,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      updateCollectionFrameOptionsAction: 'collections/updateCollectionFrameOptions',
      updateFrameCollectionInfoAction: 'collections/updateFrameCollectionInfo',
    }),
    handleOk() {
      const value = {
        value: {
          productCollectionId: this.selectedCollection.id,
          products: [
            {
              id: this.frame.id,
              options: Object.values(this.options).reduce((acc, item) => {
                const selectedOptions = item.products
                  .filter((itm) => itm.isSelected)
                  .map((opt) => ({ id: opt.id }));
                return [...acc, ...selectedOptions];
              }, []),
            },
          ],
        },
        frameInfo: {
          name: this.frame.displayName,
          productCollectionId: this.selectedCollection.id,
          id: this.frame.refProductId,
          frameId: this.frame.id,
          data: {
            subName: this.subName,
            description: this.description,
            otherDesign: this.otherDesign,
          },
        },
      };
      this.updateCollectionFrameOptionsAction(value);
      this.hideModal();
    },
    toggleOption(value) {
      const { size, id } = value;
      this.options = {
        ...this.options,
        [size]: {
          name: size,
          products: this.options[size].products.map((item) => ({
            ...item,
            isSelected: item.id === id ? !item.isSelected : item.isSelected,
          })),
        },
      };
    },
    checkIsAllSelected(value) {
      return this.options[value].isSelectedAllSizeOptions;
    },
    selectAllSizeOptions(value, size) {
      this.options = {
        ...this.options,
        [size]: {
          name: size,
          isSelectedAllSizeOptions: value,
          products: this.options[size].products.map((item) => ({
            ...item,
            isSelected: value,
          })),
        },
      };
    },
    selectAllOptions({ target: { checked } }) {
      this.options = Object.values(this.options).reduce((acc, item) => ({
        ...acc,
        [item.name]: {
          name: item.name,
          isSelectedAllSizeOptions: checked,
          products: item.products.map((opt) => ({
            ...opt,
            isSelected: checked,
          })),
        },
      }), {});
      this.isSelectedAll = checked;
    },
    saveFrameInfo() {
      this.updateFrameCollectionInfoAction({
        name: this.frame.displayName,
        productCollectionId: this.selectedCollection.id,
        id: this.frame.refProductId,
        data: {
          subName: this.subName,
          description: this.description,
          otherDesign: this.otherDesign,
        },
      });
    },
    copyLinkToClipboard(value) {
      const { productCollectionId, id, pageKey } = this.frame;
      navigator.clipboard.writeText(`https://foreverstudios.com/photo-art-editor/?collection=${productCollectionId}&frame=${id}&option=${value.id}&pageKey=${pageKey}`)
        .then(() => {
          notificationWithIcon('success', 'Link copied!');
        })
        .catch(() => {
          notificationWithIcon('error', 'Error copying link');
        });
    },
  },
  mounted() {
    this.subName = this.frame?.subName;
    this.description = this.frame?.description;
    this.otherDesign = this.frame?.otherDesign;
    const options = this.frame.options.reduce((acc, item) => {
      const {
        frameSize,
        frameOrientation,
        frameColor,
        id,
      } = item;
      const product = {
        id,
        frameOrientation,
        color: frameColor.name,
        size: frameSize.name,
        isSelected: this.selectedOptions.some((so) => so.id === id),
      };
      if (!acc[frameSize.name]) {
        return {
          ...acc,
          [frameSize.name]: {
            name: frameSize.name,
            isSelectedAllSizeOptions: product.isSelected,
            products: [product],
          },
        };
      }
      const newProducts = [...acc[frameSize.name].products, product];
      return {
        ...acc,
        [frameSize.name]: {
          name: frameSize.name,
          isSelectedAllSizeOptions: newProducts.every((itm) => itm.isSelected),
          products: newProducts,
        },
      };
    }, {});
    this.options = options;
  },
};
</script>

<template>
  <a-modal
      :open="show"
      @cancel="hideModal"
      @ok="handleOk"
      :title="frame.displayName"
      ok-text="Save"
      width="800px"
  >
    <div :class="b('')">
      <div :class="b('left-side')">
        <a-checkbox
            :checked="isSelectedAll"
            @change="selectAllOptions"
        >
          Select All
        </a-checkbox>
        <div
            :class="b('options-wrap')"
            v-for="item in options"
            :key="item.name"
        >
          <div :class="b('option-title')">
            <a-checkbox
                :checked="checkIsAllSelected(item.name)"
                @change="(e) => { selectAllSizeOptions(e.target.checked, item.name) }"
            >
            </a-checkbox>
            {{ item.name }}
          </div>
          <div :class="b('options')">
            <div :class="b('btn-wrap')"  v-for="option in item.products" :key="option.id">
              <button :class="b('link-btn')" @click="() => {copyLinkToClipboard(option)}">
                Get link
              </button>
              <a-button
                :class="b('option')"
                :type="option.isSelected ? 'primary' : 'default'"
                @click="toggleOption(option)"
              >
                <span :class="b('option-text')">{{ option.frameOrientation }}</span>
                <span :class="b('option-text')">{{ option.color }}</span>
              </a-button>
            </div>
          </div>
        </div>
      </div>
      <div :class="b('right-side')">
        <div :class="b('frame-text-wrap')">
          <div :class="b('frame-text')">Card description:</div>
          <a-input
              type="text"
              v-model:value="subName"
          />
        </div>
        <div :class="b('frame-text-wrap')">
          <div :class="b('frame-text')">Wizard description:</div>
          <a-textarea
              v-model:value="description"
              :auto-size="{ minRows: 5, maxRows: 5 }"
          />
        </div>
        <div :class="b('frame-text-wrap')">
          <div :class="b('frame-text')">Is frame prints ?</div>
          <a-switch
              checked-children="Yes"
              un-checked-children="No"
              v-model:checked="otherDesign"
          />
        </div>
        <a-button
            :class="b('save-btn')"
            @click="saveFrameInfo"
            type="primary"
            html-type="button"
        >
          Save frame info
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/media";
@import "@/styles/fonts";

.collection-frame-options {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-start;

  &__left-side,
  &__right-side {
    width: 45%;
  }

  &__frame-text-wrap {
    margin-bottom: 20px;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(20);
    }
  }

  &__options {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }

  &__option {
    width: 200px;
    height: 40px;
    margin: 10px;
    font-size: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @include mediaMinMax(1025, $normal) {
      margin: vw-full(10);
      font-size: vw-full(16);
      width: vw-full(200);
      height: vw-full(40);
    }
  }

  &__option-text {
    margin: 0 2px;

    @include mediaMinMax(1025, $normal) {
      margin: 0 vw-full(2);
    }
  }

  &__link-btn {
    background: none;
    border: none;
    cursor: pointer;
    height: fit-content;
    width: fit-content;
    text-decoration: underline;
    color: $tacao;
    margin-left: 10px;

    @include mediaMinMax(1025, $normal) {
      margin-left: vw-full(10);
    }
  }
}
.ant-modal {
  width: fit-content !important;
  max-width: 800px !important;
}
</style>
